import { ChartSeriesType } from './type';
const subStrLen = 7;

export enum TAB_NAME {
    GAMETAB = 'game_info',
}

export const TooltipHtmlContent = (series: ChartSeriesType[]) => {
    return (title: string, items: any) => {
        const html = '<div class="g2-tooltip">';
        const titleDom = `<div class="g2-tooltip-title">${title}</div>`;
        const ulDom = items.map((item: any) => {
            return `<li data-index="0" list-style-type: none; padding: 0px;">
                <svg viewBox="0 0 5 5" class="g2-tooltip-marker"
                style="width: 5px; height: 5px; border-radius: unset; display: inline-block; margin-right: 8px;">
                <path d="M2.5,2.5m-2.5,0a2.5,2.5,0,1,0,5,0a2.5,2.5,0,1,0,-5,0" fill="${
                    item.color
                }" stroke="none">
                </path></svg>${
                    series.find((e) => e.seriesName === item.name)!
                        .seriesCaption
                }
                <span class="g2-tooltip-value" style="display: inline-block; float: right; margin-left: 30px;">${
                    item.value
                }</span></li>`;
        });
        const sumDom = `<ul class="g2-tooltip-list" style="margin: 5px 0px 0px; list-style-type: none; padding: 0px;">${ulDom.join(
            '',
        )}</ul>`;
        return html + titleDom + sumDom + '</div>';
    };
};

export const LegendContainerTpl = `<div class="g2-legend" style="position:relative;">
    <ul class="g2-legend-list" style="list-style-type:none;margin:0;padding:0;display:flex;"></ul>
    </div>`;

export const multiLegendItemTpl = (
    value: any,
    color: any,
    checked: any,
    index: any,
) => {
    const show =
        value.length > subStrLen
            ? `${value.substr(0, 3)}...${value.slice(-2)}`
            : value;
    return `<li class="g2-legend-list-item item-{index} {checked}" data-color="{originColor}" data-value="{originValue}"
        style="position:relative;cursor:pointer;font-size:12px;"><span class="g2-legend-list-circle"
        style="background-color: {color}"></span>${show}<div style="display:none;" class=${
        value.length > subStrLen ? 'g2-legend-list-item-hover' : ''
    }>
        <span class="g2-legend-list-circle"
        style="background-color: {color}"></span>{value}</div></li>`;
};

export const LegendItemTpl = (
    value: any,
    color: any,
    checked: any,
    index: any,
) => {
    return `<li class="g2-legend-list-item item-{index} {checked}" data-color="{originColor}" data-value="{originValue}"
    style="position:relative;cursor:pointer;font-size:12px;"><span class="g2-legend-list-circle" style="background-color: {color}"></span>{value}</li>`;
};

export const DataLabelConfig = [
    'dimension*chartValue',
    (dimension: string, chartValue: number | string) => {
        return chartValue;
    },
    {
        position: 'top',
        offset: 10, // 5刚对齐，5+设计稿的间距
        textStyle: {
            fill: '#595959',
            fontSize: 12,
            stroke: 'white',
            lineWidth: 2,
            fontWeight: 400,
        },
    },
];

export const MixLineDataLabelConfig = [
    'dimension*lineChartValue',
    (dimension: string, chartValue: number | string) => {
        return `${(+chartValue * 100).toFixed(2)}%`;
    },
    {
        position: 'top',
        offset: 10,
        textStyle: {
            fill: '#595959',
            fontSize: 12,
            stroke: 'white',
            lineWidth: 2,
            fontWeight: 400,
        },
    },
];
export const MixBarDataLabelConfig = [
    'dimension*barChartValue',
    (dimension: string, chartValue: number | string) => {
        return chartValue;
    },
    {
        position: 'top',
        offset: 10,
        textStyle: {
            fill: '#595959',
            fontSize: 12,
            stroke: 'white',
            lineWidth: 2,
            fontWeight: 400,
        },
    },
];
export const CommonChartConfig = {
    scale: [
        {
            dataKey: 'dimension',
            type: 'cat',
            tickCount: 8,
        },
        {
            dataKey: 'chartValue',
            min: 0,
            formatter: function formatter(text: number) {
                return +text >= 10000
                    ? (+text - (+text % 1000)) / 10000 + 'w'
                    : text;
            },
        },
    ],
    padding: [30, 45, 80, 70],
    XLabel: {
        textStyle: {
            fill: '#262626',
            fontSize: 12,
        },
    },
    XTickLine: {
        length: 4, // 竖线长度
        lineWidth: 1, // 竖线宽度
        stroke: '#D8D8D8', // 竖线颜色
    },
    XAxisLine: {
        // X轴颜色
        stroke: '#D8D8D8',
    },
    YLabel: {
        textStyle: {
            // 左边y轴的字体颜色
            fill: '#262626',
            fontSize: 12,
        },
    },
    color: ['chartKey', ['#36CFA2', '#F6B502']],
    YGrid: {
        lineStyle: {
            stroke: '#D8D8D8',
            lineWidth: 1,
        },
    },
    legendAllowAllCanceled: false,
    pointStyle: {
        stroke: '#fff',
        lineWidth: 1,
    },
    barAdjust: [
        {
            type: 'dodge',
            marginRatio: 1 / 32,
            intervalPadding: 5,
        },
    ],
    crosshairs: {
        type: 'y',
    },
};

export const GameChartConfig = {
    ...CommonChartConfig,
    padding: [30, 10, 80, 70],
};

export const DimensionFormatMap = {
    day: {
        type: 'yyyy/MM/dd',
        dimensionType: 0,
    },
    month: {
        type: 'yyyy/MM',
        dimensionType: 2,
    },
    quarter: {
        type: 'quarter',
        dimensionType: 3,
    },
};
